export default __webpack_public_path__ + "static/media/ras.2ac0bdf7.png";